import React, { useEffect, useState } from "react";
import PartnerLayout, { tenantSlugFor } from "@/components/PartnerLayout";
import { useAuth } from "@/context/AuthContext";
import { api, BACKEND_URL } from "@/lib/api";
import { Download } from "lucide-react";
import { toast } from "sonner";

export default function Reportes() {
  const { user } = useAuth();
  const slug = tenantSlugFor(user);
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get(`/partner/${slug}/reports/by-program`).then((r) => setRows(r.data));
  }, [slug]);

  const download = async (fmt) => {
    try {
      const r = await api.get(`/partner/${slug}/reports/export?format=${fmt}`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement("a"); a.href = url;
      a.download = `reporte-${slug}.${fmt}`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch { toast.error("No se pudo descargar"); }
  };

  return (
    <PartnerLayout user={user}>
      <div>
        <div className="flex items-end justify-between flex-wrap gap-3 mb-6">
          <div>
            <p className="text-xs uppercase tracking-widest text-[#93C5FD] font-semibold">Reportes</p>
            <h1 className="mt-2 text-3xl font-bold text-white font-display">Reportes por programa</h1>
          </div>
          <div className="flex gap-2">
            <button onClick={() => download("csv")} data-testid="export-csv"
              className="inline-flex items-center gap-1 px-4 py-2 rounded-md border border-gray-700 text-white text-sm hover:bg-white/5">
              <Download className="w-4 h-4" /> CSV
            </button>
            <button onClick={() => download("xlsx")} data-testid="export-xlsx"
              className="inline-flex items-center gap-1 px-4 py-2 rounded-md bg-[#B84A0C] hover:bg-primary text-white text-sm">
              <Download className="w-4 h-4" /> XLSX
            </button>
          </div>
        </div>

        <div className="overflow-x-auto border border-gray-800 rounded-xl">
          <table className="w-full text-sm">
            <thead className="bg-[#0F172A] text-xs uppercase tracking-widest text-gray-400">
              <tr>
                <th className="text-left px-4 py-3">Programa</th>
                <th className="text-left px-4 py-3">Código</th>
                <th className="text-right px-4 py-3">Licencias</th>
                <th className="text-right px-4 py-3">Activadas</th>
                <th className="text-right px-4 py-3">Progreso</th>
                <th className="text-right px-4 py-3">Certs</th>
                <th className="text-right px-4 py-3">Completion</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.program_id} className="border-t border-gray-800 hover:bg-white/[0.02]">
                  <td className="px-4 py-3 text-white">{r.program_title}</td>
                  <td className="px-4 py-3 font-mono text-gray-400">{r.program_code}</td>
                  <td className="px-4 py-3 text-right text-white">{r.licenses_total}</td>
                  <td className="px-4 py-3 text-right text-white">{r.licenses_activated}</td>
                  <td className="px-4 py-3 text-right text-white">{r.avg_progress_percent}%</td>
                  <td className="px-4 py-3 text-right text-white">{r.certificates}</td>
                  <td className="px-4 py-3 text-right text-white">{r.completion_rate}%</td>
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-gray-500">Sin datos.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </PartnerLayout>
  );
}
